import {create} from 'zustand';
import {persist, createJSONStorage, devtools} from 'zustand/middleware';

export const useNavigationStore = create(
    devtools(
        persist(
            (set) => ({
              primary: '',
              secondary: '',

              setPrimary: (newUbication) =>
                set(() => ({primary: newUbication}), false, 'setPrimary'),
              setSecondary: (newUbication) =>
                set(() => ({secondary: newUbication}), false, 'setSecondary'),
            }), {
              name: 'navigation-storage',
              storage: createJSONStorage(() => sessionStorage),
            },
        ),
        {name: 'NavigationStore'},
    ),
);
